import { render, staticRenderFns } from "./leave_details.vue?vue&type=template&id=23d9e27e&scoped=true&"
import script from "./leave_details.vue?vue&type=script&lang=js&"
export * from "./leave_details.vue?vue&type=script&lang=js&"
import style0 from "./leave_details.vue?vue&type=style&index=0&id=23d9e27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9e27e",
  null
  
)

export default component.exports